import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PrescriptionOutputDialogComponent } from 'src/app/dialogs/prescription/prescription-output-dialog/prescription-output-dialog.component';
import { ValidateDialogComponent } from 'src/app/dialogs/validate-dialog/validate-dialog.component';
import { WaitingDialogComponent } from 'src/app/dialogs/waiting-dialog/waiting-dialog.component';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';
import { ContactService } from 'src/app/services/contact.service';
import { PrescriptionService } from 'src/app/services/prescription.service';
import { TypeManagerService } from 'src/app/services/type-manager.service';
import { UserOpenItemsService } from 'src/app/services/user-open-items.service';

@Component({
  selector: 'app-contact-row-prescription',
  templateUrl: './contact-row-prescription.component.html',
  styleUrls: ['./contact-row-prescription.component.scss']
})
export class ContactRowPrescriptionComponent implements OnInit {

  private consultation: CNConsultation;
  public entries: CNPrescriptionEntry[] = [];

  constructor(private prescriptions: PrescriptionService, private typeManager: TypeManagerService,
              private dialog: MatDialog, private contactservice: ContactService,
              private userOpenItems: UserOpenItemsService) { }

  ngOnInit(): void {
  }

  @Input() set item(theitem: CNConsultation) {
    this.consultation = theitem;
    const prescription = theitem.prescription;
    if (prescription) {
      if (typeof prescription.entries === 'undefined') {}
      prescription.childs('SNItem.CNItem.CNPrescriptionEntry').subscribe(childs => {
        if (childs instanceof Array) {
          this.entries = childs as CNPrescriptionEntry[];
        }
      });
    }
  }

  get item(): CNConsultation {
    return this.consultation;
  }

  editPrescription() {
    // Load prescription entries
    this.item.prescription.childs('SNItem.CNItem.CNPrescriptionEntry').subscribe(entries => {
      // Open comment dialog
      if (this.typeManager.typeMap('PrescriptionDialogComponent')) {
        const componentFactory = this.typeManager.typeMap('PrescriptionDialogComponent');
        const dialogRef = this.dialog.open(componentFactory, {
            data: {
              prescription: this.item.prescription
            }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.contactservice.load();
          }
        });
      }
    });
  }

  printPrescription() {
    const dialogRef = this.dialog.open(PrescriptionOutputDialogComponent, {
      data: {
        prescription: this.item.prescription
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  sendPrescription() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Voulez-vous envoyer cette prescription ?',
      ok: {
        label: 'Envoyer',
        code: 'ok'
      },
      cancel: {
        label: 'Annuler',
        code: 'cancel'
      }
    };
    const dialogRef = this.dialog.open(ValidateDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'ok') {
        this.prescriptions.sendPrescription(this.item.prescription).subscribe(updatedPrescription => {
          this.item.prescription = updatedPrescription;
          const dialogPrescriptionRef = this.dialog.open(PrescriptionOutputDialogComponent, {
            data: {
              prescription: this.item.prescription
            }
          });
          // reload contacts
          this.contactservice.load();
        });
      }
    });
  }

  smsPrescription() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Voulez-vous envoyer cette prescription par SMS ?',
      ok: {
        label: 'Envoyer',
        code: 'ok'
      },
      cancel: {
        label: 'Annuler',
        code: 'cancel'
      }
    };
    const dialogRef = this.dialog.open(ValidateDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'ok') {
        const waitDailogData = {
          data: {
            title: 'Envoi en cours ...',
            error: undefined,
            result: undefined
          }
        };
        const waitDialog = this.dialog.open(WaitingDialogComponent, waitDailogData);
        this.prescriptions.smsPrescription(this.item.prescription).subscribe(smsresult => {
          waitDailogData.data.result = 'Message envoyé',
          setTimeout(() => {
            waitDialog.close();
          }, 2000);
        }, error => {
          waitDailogData.data.error = error;
          setTimeout(() => {
            waitDialog.close();
          }, 2000);
        });
      }
    });
  }

  addPrescription(): void {
    const opendedContact = this.userOpenItems.items('stvaast_consultation');
    let newConsult: CNConsultation;
    if (opendedContact.length !== 0) {
      // find one new consultation
      newConsult = opendedContact.find(contact => contact.id === 0) as CNConsultation;
    }
    
  }
}
